import Ajv, { JSONSchemaType, ValidateFunction } from "ajv";

// Store given type of items in localStorage as JSON, with schema-based validation.
// T is the actual type stored in localStorage, while U is user serialized/deserialized type.
// Schema is for T, i.e. object is first serialized, then validated (opposite order for get()).
// TODO: provide a variant LocalStorageDirect<T, T>
export class LocalStorage<T, U> {
  private validate: ValidateFunction<T>;

  constructor(
    private key: string,
    private schema: JSONSchemaType<T>,
    private serialize: (val: U) => T | undefined,
    private parse: (val: T) => U | undefined
  ) {
    const ajv = new Ajv();
    this.validate = ajv.compile<T>(this.schema);
  }

  public get(): U | undefined {
    const item = localStorage.getItem(this.key);
    if (item == undefined) return;

    const value = JSON.parse(item);
    if (!this.validate(value)) return;

    return this.parse(value);
  }

  public set(user: U): boolean {
    const value = this.serialize(user);
    if (value == undefined) return false;

    if (!this.validate(value)) return false;

    const json = JSON.stringify(value);
    localStorage.setItem(this.key, json);
    return true;
  }

  public clear() {
    localStorage.removeItem(this.key);
  }
}
